import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/connector-types")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/connectors/types", search: location.search, replace: true });
  },
  component: () => null,
});
